import React, { useState, useEffect } from 'react';
import {
    Button,
    Col,
    Input,
    Row,
    Label,
    ModalBody,
    Form,
    TabPane,
    TabContent,
    FormFeedback,
    FormGroup,
    ModalFooter,
} from 'reactstrap';

// Formik
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';

//redux
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import OSelect from '../../../Components/OElements/OSelect';
import { getDistanceUnitList } from '../../../slices/thunks';
import { getIntakeCoordinatesList } from '../../../slices/intakeCoordinates/thunk';
import { getRestitutionCoordinatesList } from '../../../slices/restitutionCoordinates/thunk';

const DistancesAndElevationForm = ({
    dataDistanceElevation,
    handleToggleModal,
    isEdit,
    isOpen,
    handleSave,
    waterRightId,
    intakeCoordinatesList = [],
    restitutionCoordinatesList = [],
}) => {
    const dispatch = useDispatch();

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            distance: dataDistanceElevation?.distance || '',
            distance_unit: dataDistanceElevation?.distance_unit?._id || dataDistanceElevation?.distance_unit || '',
            elevation_difference: dataDistanceElevation?.elevation_difference || dataDistanceElevation?.elevation || '',
            intake_coordinates_id: dataDistanceElevation?.intake_coordinates_id || dataDistanceElevation?.intake_coordinates?._id || '',
            restitution_coordinates_id: dataDistanceElevation?.restitution_coordinates_id || dataDistanceElevation?.restitution_coordinates?._id || '',
        },
        validationSchema: Yup.object({
            distance: Yup.number().required('Campo requerido').min(0, 'Debe ser mayor o igual a 0'),
            distance_unit: Yup.string().required('Campo requerido'),
            elevation_difference: Yup.number().required('Campo requerido'),
            intake_coordinates_id: Yup.string().nullable(),
            restitution_coordinates_id: Yup.string().nullable(),
        }),
        onSubmit: async (values) => {
            handleSave(values);
            validation.resetForm();
        },
    });

    return (
        <Form
            className='tablelist-form'
            onSubmit={e => {
                e.preventDefault();
                return false;
            }}
        >
            <ModalBody className='modal-body'>
                <TabContent activeTab={'1'}>
                    <TabPane tabId='1'>
                        <Row className='g-3'>
                            <Col lg={6} className='mb-3'>
                                <Label for='distance' className='form-label'>
                                    Distancia <span className='text-danger'>*</span>
                                </Label>
                                <Input
                                    name='distance'
                                    id='distance'
                                    className='form-control'
                                    type='number'
                                    step='any'
                                    value={validation.values.distance || ''}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={!!(validation.touched.distance && validation.errors.distance)}
                                />
                                {validation.touched.distance && validation.errors.distance && (
                                    <FormFeedback>{validation.errors.distance}</FormFeedback>
                                )}
                            </Col>
                            <Col lg={6} className='mb-3'>
                                <OSelect
                                    key='distance_unit'
                                    label='Unidad Distancia'
                                    id='distance_unit'
                                    name='distance_unit'
                                    value={validation.values.distance_unit || ''}
                                    isRequired
                                    validation={validation}
                                    requestApi={() => dispatch(getDistanceUnitList()).then(res => res.payload)}
                                />
                            </Col>
                            <Col lg={12} className='mb-3'>
                                <Label for='elevation_difference' className='form-label'>
                                    Desnivel (m) <span className='text-danger'>*</span>
                                </Label>
                                <Input
                                    name='elevation_difference'
                                    id='elevation_difference'
                                    className='form-control'
                                    type='number'
                                    step='any'
                                    value={validation.values.elevation_difference || ''}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={!!(validation.touched.elevation_difference && validation.errors.elevation_difference)}
                                />
                                {validation.touched.elevation_difference && validation.errors.elevation_difference && (
                                    <FormFeedback>{validation.errors.elevation_difference}</FormFeedback>
                                )}
                            </Col>
                            <Col lg={6} className='mb-3'>
                                <OSelect
                                    key='intake_coordinates_id'
                                    label='Coordenada de Captación'
                                    id='intake_coordinates_id'
                                    name='intake_coordinates_id'
                                    value={validation.values.intake_coordinates_id || ''}
                                    validation={validation}
                                    value_key={waterRightId ? '_id' : 'name'}
                                    requestApi={
                                        waterRightId
                                            ? () => dispatch(getIntakeCoordinatesList({ water_right_id: waterRightId })).then(res => res.payload)
                                            : () => new Promise(resolve => setTimeout(() => resolve(intakeCoordinatesList), 0))
                                    }
                                />
                            </Col>
                            <Col lg={6} className='mb-3'>
                                <OSelect
                                    key='restitution_coordinates_id'
                                    label='Coordenada de Restitución'
                                    id='restitution_coordinates_id'
                                    name='restitution_coordinates_id'
                                    value={validation.values.restitution_coordinates_id || ''}
                                    validation={validation}
                                    value_key={waterRightId ? '_id' : 'name'}
                                    requestApi={
                                        waterRightId
                                            ? () => dispatch(getRestitutionCoordinatesList({ water_right_id: waterRightId })).then(res => res.payload)
                                            : () => new Promise(resolve => setTimeout(() => resolve(restitutionCoordinatesList), 0))
                                    }
                                />
                            </Col>
                        </Row>
                    </TabPane>
                </TabContent>
            </ModalBody>
            <ModalFooter>
                <div className='hstack gap-2 justify-content-end'>
                    <Button
                        type='button'
                        onClick={() => {
                            handleToggleModal();
                        }} className='btn-danger btn-label'>
                        <i className="ri-close-line label-icon"></i>
                        Cancelar
                    </Button>
                    <button
                        type='button'
                        className='btn btn-label btn-primary'
                        onClick={() => {
                            validation.handleSubmit();
                        }}
                    >
                        <i className='ri-save-line label-icon'></i>
                        Guardar
                    </button>
                </div>
            </ModalFooter>
        </Form>
    );
};

export default DistancesAndElevationForm;
